import { FormikHelpersRef } from "../types";

/**
 * Domain rules applied on every value change of the installed base node form
 * (EditNodeModal and the detail panel's Information tab share this).
 */
export const applyInstalledBaseNodeValueRules = (
    values: { [key: string]: any },
    formikHelpers: Pick<FormikHelpersRef, "setFieldValue"> | null,
) => {
    // Batch tools are always strategic. Guard against re-setting: setFieldValue
    // creates a new values object even for an unchanged value, which would
    // re-trigger the values-change callback in a loop.
    if (values.waferType === "BATCH" && values.strategicTool !== true) {
        formikHelpers?.setFieldValue("strategicTool", true);
    }
};
